module.exports = __webpack_public_path__ + "img/sapporo.74e7375a.png";